import { Routes } from '@angular/router';

// Guard
import { PostEnrollmentGopaperlessComponent } from './containers/post-enrollment-gopaperless/post-enrollment-gopaperless.component';
import { PostEnrollmentGuard } from './post-enrollment.guard';

export const ProgramRoutes: Routes = [
  {
    path: 'program',
    children: [
      {
        path: 'gopaperless',
        canActivate: [PostEnrollmentGuard],
        data: {
          redirectRoute: '/not-found'
        },
        component: PostEnrollmentGopaperlessComponent
      }
    ]
  }
];
